import React, { useState } from "react";
import styled from "styled-components";
import { cssTemplate, media } from "../../../../constants/styles";
import { useIntersecting } from "../../../../hooks/useIntersecting";
import Text from "./Text";
import Button from "../../../Button";
import useInterval from "../../../../hooks/useInterval";
import { DEFAULT_INTERVAL } from "../../../../constants/animationValue";

interface LastSectionProps { }

const LastSection: React.FC<LastSectionProps> = () => {
  const { ref, isIntersecting } = useIntersecting();

  const [isInteracted, setIsInteracted] = useState<number>(-1);
  const handleClickButton = (e: React.MouseEvent) => {
    e.preventDefault();
    window.open("https://www.rocketpunch.com/companies/slogup/jobs", "_blank");
  };
  useInterval(
    () => {
      setIsInteracted(isInteracted + 1);
    },
    isIntersecting ? (isInteracted > 3 ? null : DEFAULT_INTERVAL) : null
  );
  return (
    <Container>
      <SectionWrapper>
        <ContentWrapper>
          <TextWrapper
            ref={ref}
            theme={{ isIntersecting: isInteracted >= 1 }}
            style={{ alignItems: "center" }}
          >
            <Text
              smallText="Come Grow With Us"
              bigText={
                <>
                  우리 함께 일해요!
                  <br />
                  새로운 슬로거를 환영합니다.
                </>
              }
            />
          </TextWrapper>
          <Button
            isIntersecting={isInteracted >= 2}
            isAnimated={false}
            label="채용 알아보기"
            onClick={handleClickButton}
          ></Button>
        </ContentWrapper>
      </SectionWrapper>
    </Container>
  );
};

export default LastSection;
const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  ${media.TABLET} {
    display: block;
  }
`;
const SectionWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 160px;
  isolation: isolate;
  min-height: 830px;
  width: 100%;

  padding: 160px 0px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url("/image/webp/recruit/FooterImg-Pc.webp");

  &:before {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    content: " ";
  }
  ${media.TABLET} {
    background-image: url("/image/webp/recruit/FooterImg-Tablet.webp");
    &:before {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0);
      content: " ";
    }
    min-height: 596px;
  }
  ${media.MOBILE} {
    min-height: 388px;
  }
`;
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0px;
  gap: 60px;
  ${media.TABLET} {
    gap: 40px;
  }
  ${media.MOBILE} {
    gap: 24px;
  }
  & > img {
  }
`;
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 40px;
  ${(props) => cssTemplate.fadeInOut(props)};
  ${media.TABLET} {
    gap: 24px;
  }
  ${media.MOBILE} {
    gap: 12px;
  }
`;
